module.exports = __webpack_public_path__ + "static/media/icon_event_goal.cff6a026.svg";